import { memo } from 'react';
import { Divider, Flex, Text, Box } from '@cad-arc';
import AniAliIcon from '../../../../esri/images/phone-icons/unselected/ani_ali_unselected.svg';
import { getCallSource } from '../../../../phone-calls/helpers';
import { CommonSize, formatMonthDayYearHoursMinutes } from '../../../../common/helpers/utils';
import { CloseMapLedgerAndClearSelectedEntityButton } from '../close-map-ledger-and-clear-selected-entity-button';

export const PhoneCallOverview = memo(function honeCallOverview({
    label,
    createdDateUtc,
    classOfService,
    size,
}: {
    label?: string;
    createdDateUtc?: string;
    classOfService?: string;
    size?: CommonSize;
}): React.ReactElement {
    return (
        <>
            <Box padding="12px 18px">
                <Flex alignItems="center" justifyContent="space-between">
                    <Flex gap={2} alignItems="center">
                        <Flex alignItems="center" w={40}>
                            <img src={AniAliIcon} alt="icon" />
                        </Flex>
                        <Text fontSize={size} fontWeight="bold" style={{ wordBreak: 'break-word' }}>
                            {label}
                        </Text>
                        <Text fontSize={size}>
                            {formatMonthDayYearHoursMinutes(createdDateUtc!)}
                        </Text>
                    </Flex>
                    <CloseMapLedgerAndClearSelectedEntityButton />
                </Flex>
                <Text fontSize={size}>{getCallSource(classOfService!)}</Text>
            </Box>
            <Divider />
        </>
    );
});
